<template>
	<div class="sheet-backdrop">
		<f7-sheet style="height: 24rem;" :opened="show" @sheet:closed="closePeriodSelect" backdrop :params="{backdropEl:$el,animate:false,scrollToEl:'.aaa'+curIndex}">
			<f7-toolbar class="jxc_bottom_line" style="background-color: white;">
				<div class="left dz-font-size-14 dz-p7" @click="closePeriodSelect">取消</div>
				<div v-if="type == 2" class=" flex-between dz-font-size-16" style="width: 7.75rem; height: 100%;">
					<div style="width: 2rem; text-align: center;" :style="isQuarter?'color: #929292;':''" @click="isQuarter = false">
						月度
						<div v-if="!isQuarter" class="tab_flag"></div>
					</div>
					<div style="width: 2rem; text-align: center;" :style="isQuarter?'':'color: #929292;'" @click="isQuarter = true">
						季度
						<div v-if="isQuarter" class="tab_flag"></div>
					</div>
				</div>
				<div v-else class="title dz-font-size-18">请选择期间</div>
				<div class="right dz-font-size-14 dz-p7 fg-color-primary" @click="emit">确定</div>
			</f7-toolbar>
			<f7-page-content style="padding-bottom: 3rem;" bgColor="white">
				<div v-for="(item, index) in list" :key="index" class="dz-font-size-18" :class="'aaa'+index">
					<div class="dz-m15-left" style="margin-top: 1.5rem;">{{item.Year}}</div>
					<!-- 月度 -->
					<div v-if="type == 0||(type == 2&&!isQuarter)||type >= 3" class="flex-wrap">
						<div v-for="(innerItem, i) in item.InnerList" :key="i" @click="select(item.Year, innerItem, i),curIndex = index;" style="margin-top: 0.9375rem;" :style="innerItem.Month==6||innerItem.Month==12||innerItem.Month==1||innerItem.Month==7?'width: 21.2%;':'width: 14.4%;'">
							<div v-if="innerItem.Month==6||innerItem.Month==12" style="width: 100%;" 
								:class="{'bg_section1':isSection(innerItem),'bg_section_start':innerItem.Key==Pid0, 'bg_section_end':innerItem.Key==Pid1}">
								<div style="width: 67.92%; float: right;">
									<div class="month_box" :class="{'month_checked':innerItem.Key==Pid1||innerItem.Key==Pid0,'month_unselected':innerItem.Key<0}">{{innerItem.Month}}</div>
								</div>
							</div>
							<div v-else-if="innerItem.Month==1||innerItem.Month==7" style="width: 100%;" 
									:class="{'bg_section2':isSection(innerItem),'bg_section_start':innerItem.Key==Pid0, 'bg_section_end':innerItem.Key==Pid1}">
								<div style="width: 67.92%;">
									<div class="month_box" :class="{'month_checked':innerItem.Key==Pid1||innerItem.Key==Pid0,'month_unselected':innerItem.Key<0}">{{innerItem.Month}}</div>
								</div>
							</div>
							<div v-else style="width: 100%;" 
								:class="{'bg_section3':isSection(innerItem),'bg_section_start':innerItem.Key==Pid0, 'bg_section_end':innerItem.Key==Pid1}">
								<div class="month_box" :class="{'month_checked':innerItem.Key==Pid1||innerItem.Key==Pid0,'month_unselected':innerItem.Key<0}">{{innerItem.Month}}</div>
							</div>
						</div>
					</div>
					<!-- 季度 -->
					<div v-else class="flex-between dz-font-size-14" style="margin: 0.9375rem 1.5625rem 0;">
						<div v-for="(quarterItem, i) in item.QuarterList" :key="i" @click="selectQuarter(item.Year, quarterItem)" class="quarter_box" :class="{'quarter_checked':quarterItem.Key==Pid2,'quarter_unselected':quarterItem.Key<0}">
							{{quarterItem.Quarter}}
						</div>
					</div>
				</div>
			</f7-page-content>
		</f7-sheet>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				list: [],
				Pid0: "",
				Pname0: "",
				Pid1: "",
				Pname1: "",
				Pid2: "",
				Pname2: "",
				showValue: "",
				showLabel: "",
				isQuarter: false,
				isShowQuarter: false,
				curYear: 0,
				curIndex: 5,
			}
		},
		props: {
			// 是否显示弹框
			show: Boolean,
			// 选中数据的key
			value: [String, Array],
			// 选中数据的name
			label: String,
			//类别：0 月（期）；1 季度；2 月度季度可切换；3 区间选择; 4 代账选择器
			type: {
				type: Number,
				default: 0,
			},
			//是否需要预加载季度（针对type==0）
			isPer: {
				type: Boolean,
				default: false,
			},
			suffix: {
				type: String,
				default: "期",
			}

		},
		watch: {
			type(newValue, oldValue) {
				console.log(newValue + "===>" + oldValue)
				this.emit();
			},
			show(newValue, oldValue) {
				if (this.type != 4) return;
				if (newValue) {
					this.$setShowPeriod(newValue)
					this.$nextTick(() => {
						console.log(this.curIndex)
						var target = document.querySelector('.aaa' + this.curIndex);
						target.parentNode.scrollTop = target.offsetTop;
					})

				} else {
					setTimeout(() => {
						this.$setShowPeriod(newValue)
					}, 700)
				}
			}
		},
		mounted() {
			this.$f7.emit('initPageData', this.initData);
		},
		methods: {
			initData() {
				console.log('type',this.type)
				if (this.type == 4) {
					var date = new Date();
					this.curYear = date.getFullYear();
					var curMonth = date.getMonth() + 1;
					this.$set(this, "Pname1", this.curYear + "年" + (curMonth < 10 ? "0" + curMonth : curMonth) + this.suffix);
					this.emit();
					var k = 1;
					for (var i = this.curYear + 5; i > 1999; i--) {
						let groups = [];
						for (var j = 12; j > 0; j--) {
							groups.push({
								Key: k,
								Month: Number(j) < 10 ? "0" + j : j
							})
							if (i == this.curYear && j == curMonth) {
								this.Pid1 = k;
							}
							k++;
						}
						this.list.push({
							Year: i + "年",
							InnerList: groups
						})
					}
					return;
				}
				var groups = {};
				console.log('store_PeriodSection',this.store_PeriodSection)
				this.store_PeriodSection.forEach(item => {
					var year = item.Value.substring(0, 5);
					var month = item.Value.substring(6, item.Value.length - 1);
					groups[year] = groups[year] || [];
					this.$set(item, "Month", Number(month) < 10 ? "0" + month : month);
					this.$set(item, "Key", item.Key * 1);
					groups[year].push(item);
				});
				Object.keys(groups).forEach(key => {
					this.list.push({
						Year: key,
						InnerList: groups[key]
					});
				});

				if (this.list && this.list.length > 0) {
					let arr1 = this.list[0].InnerList;
					//返回一条数据
					if (this.type == 3 && this.value && this.value.length > 1) {
						this.$set(this, "Pid1", this.value[0]);
						this.$set(this, "Pid0", this.value[1]);

						for (var i = 0; i < this.list.length; i++) {
							for (var j = 0; j < this.list[i].InnerList.length; j++) {
								if (this.list[i].InnerList[j].Key == this.value[0]) {
									this.$set(this, "Pname1", this.list[i].Year + this.list[i].InnerList[j].Month + this.suffix);
								}
								if (this.list[i].InnerList[j].Key == this.value[1]) {
									this.$set(this, "Pname0", this.list[i].Year + this.list[i].InnerList[j].Month + this.suffix);
								}
							}
						}
					} else {
						//获取第一条
						this.Pid1 = arr1[0].Key;
						this.$set(this, "Pname1", this.list[0].Year + arr1[0].Month + this.suffix);
						if (this.type == 3) {
							this.$set(this, "Pid0", this.Pid1);
							this.$set(this, "Pname0", this.Pname1);
						}
					}
					this.emit();
					if (this.type == 1 || this.isPer) {
						this.$set(this, "Pid2", this.Pid1);
					}

					for (var i = arr1[0].Month * 1 + 1; i < 13; i++) {
						arr1.unshift({
							"Key": -1,
							"Month": Number(i) < 10 ? "0" + i : i,
						});
					}
					let arr2 = this.list[this.list.length - 1].InnerList;
					for (var i = 12 - arr2.length; i > 0; i--) {
						arr2.push({
							"Key": -1,
							"Month": Number(i) < 10 ? "0" + i : i,
						});
					}
				}
				if (this.type == 1 || this.type == 2 || this.isPer) {
					this.list.forEach(item => {
						this.$set(item, "QuarterList", [{
							"Quarter": "第一季",
							"Key": -1,
						}, {
							"Quarter": "第二季",
							"Key": -1,
						}, {
							"Quarter": "第三季",
							"Key": -1,
						}, {
							"Quarter": "第四季",
							"Key": -1,
						}]);
						for (var i = 11; i >= 0; i--) {
							let pos = parseInt((Number(item.InnerList[i].Month) - 1) / 3);
							let k = item.InnerList[i].Key;
							if (k > 0) {
								this.$set(item.QuarterList[pos], "Key", k);
								if (this.type != 2 && k == this.Pid2) {
									this.$set(this, "Pname2", item.Year + item.QuarterList[pos].Quarter);
								}
							}
						}
					});
				}
				console.log('Pid1',this.Pid1)
				console.log('Pid0',this.Pid0)
				console.log('list',this.list)
			},
			select(year, item) {
				if (item.Key < 0) return;
				if (this.type != 3) {
					this.$set(this, "Pid1", item.Key);
					this.$set(this, "Pname1", year + item.Month + this.suffix);
					if (this.type == 2) {
						this.$set(this, "Pid2", "");
						this.$set(this, "Pname2", "");
					}
				} else {
					if (this.Pid1 > 0) {
						this.$set(this, "Pid0", item.Key);
						this.$set(this, "Pname0", year + item.Month + this.suffix);
						this.$set(this, "Pid1", 0);
					} else if (item.Key <= this.Pid0) {
						this.$set(this, "Pid1", item.Key);
						this.$set(this, "Pname1", year + item.Month + this.suffix);
					} else {
						this.$set(this, "Pid1", this.Pid0);
						this.$set(this, "Pname1", this.Pname0);
						this.$set(this, "Pid0", item.Key);
						this.$set(this, "Pname0", year + item.Month + this.suffix);
					}
				}
			},
			selectQuarter(year, item) {
				if (item.Key < 0) return;
				this.$set(this, "Pid2", item.Key);
				this.$set(this, "Pname2", year + item.Quarter);
				if (this.type == 2) {
					this.$set(this, "Pid1", "");
					this.$set(this, "Pname1", "");
				}
			},
			emit() {
				if (this.type == 3) {
					if (this.Pid1 <= 0) {
						this.$set(this, "Pid1", this.Pid0)
						this.$set(this, "Pname1", this.Pname0)
					}
					this.$set(this, "showValue", [this.Pid1, this.Pid0]);
					if (this.Pid1 == this.Pid0) {
						this.$set(this, "showLabel", this.Pname0);
					} else {
						this.$set(this, "showLabel", this.Pname1 + " - " + this.Pname0);
					}
				} else if (this.type == 0 || (this.type == 2 && !this.isQuarter) || this.type == 4) {
					this.$set(this, "showValue", this.Pid1.toString());
					this.$set(this, "showLabel", this.Pname1);
				} else {
					this.$set(this, "showValue", this.Pid2.toString());
					this.$set(this, "showLabel", this.Pname2);
				}
				if (this.type == 2) {
					this.$set(this, "isShowQuarter", this.isQuarter);
				}
				this.$emit("input", this.showValue);
				this.$emit("update:label", this.showLabel);
				this.$emit("update:show", false);
			},
			closePeriodSelect() {
				this.$emit("update:show", false);
				if (this.type == 0 || (this.type == 2 && !this.isShowQuarter)) {
					this.$set(this, "Pid1", this.showValue);
					this.$set(this, "Pname1", this.showLabel);
					if (this.type == 2) {
						this.$set(this, "Pid2", "");
						this.$set(this, "Pname2", "");
					}
				} else {
					this.$set(this, "Pid2", this.showValue);
					this.$set(this, "Pname2", this.showLabel);
					if (this.type == 2) {
						this.$set(this, "Pid1", "");
						this.$set(this, "Pname1", "");
					}
				}
				if (this.type == 2) {
					this.$set(this, "isQuarter", this.isShowQuarter);
				}
			},
			isSection(item) {
				return this.type == 3 && this.Pid1 > 0 && item.Key <= this.Pid0 && item.Key >= this.Pid1;
			}
		}
	}
</script>
<style scoped="scoped" lang="less">
	.month_box {
		width: 2.5rem;
		height: 2.5rem;
		margin: 0 auto;
		text-align: center;
		line-height: 2.5rem;
	}

	.month_checked {
		background-color: @primary-color;
		border-radius: 2.5rem;
		color: white;
	}

	.month_unselected {
		color: #9D9EAE;
	}

	.quarter_box {
		width: 3.75rem;
		height: 1.5625rem;
		text-align: center;
		line-height: 1.5625rem;
	}

	.quarter_checked {
		background-color: @primary-color;
		border-radius: 0.25rem;
		color: white;
	}

	.quarter_unselected {
		color: #DADADA;
	}

	.tab_flag {
		width: 2rem;
		height: 0.125rem;
		background-color: @primary-color;
		border-radius: 0.125rem;
		position: absolute;
		bottom: 0.0625rem;
	}

	.bg_section1 {
		position: relative;
		z-index: 1;
		overflow: hidden;

		::before {
			content: '';
			display: block;
			width: 69%;
			height: 100%;
			position: absolute;
			top: 0;
			left: -1px;
			z-index: -1;
			background-color: #E3F8EC;
		}

		::after {
			content: '';
			display: block;
			width: 35%;
			height: 100%;
			position: absolute;
			top: 0;
			right: -1px;
			z-index: -1;
			background-color: #E3F8EC;
		}
	}

	.bg_section2 {
		position: relative;
		z-index: 1;
		overflow: hidden;

		::before {
			content: '';
			display: block;
			width: 35%;
			height: 100%;
			position: absolute;
			top: 0;
			left: -1px;
			z-index: -1;
			background-color: #E3F8EC;
		}

		::after {
			content: '';
			display: block;
			width: 69%;
			height: 100%;
			position: absolute;
			top: 0;
			right: -1px;
			z-index: -1;
			background-color: #E3F8EC;
		}
	}

	.bg_section3 {
		position: relative;
		z-index: 1;
		overflow: hidden;

		::before {
			content: '';
			display: block;
			width: 52%;
			height: 100%;
			position: absolute;
			top: 0;
			left: -1px;
			z-index: -1;
			background-color: #E3F8EC;
		}

		::after {
			content: '';
			display: block;
			width: 52%;
			height: 100%;
			position: absolute;
			top: 0;
			right: -1px;
			z-index: -1;
			background-color: #E3F8EC;
		}
	}

	.bg_section_start {
		::before {
			display: none;
		}
	}

	.bg_section_end {
		::after {
			display: none;
		}
	}
</style>
